export const useTransactionsController = () => {
  const userStore = useUserStore();
  const { $serverApi } = useNuxtApp();
  const { web3Sign } = useWeb3();
  const txId = ref<string | null>(null);
  const userSignature = ref<string | null>(null);

  const getEstimatedGasFees = async (transactionType: TransactionType) => {
    const gasResponse = await $serverApi<GFALResponse<GasFees>>(
      `/api/transactions/gas-fees?type=${transactionType}`,
      {
        headers: constructHeaders(userStore.authToken),
      }
    );
    return gasResponse.payload;
  };

  const transfer = async (
    token: string,
    to: string,
    amount: string
  ): Promise<GFALResponse<Transaction>> => {
    const transactionResponse = await createTransaction(token, to, amount);
    if (!transactionResponse.payload) return transactionResponse;
    txId.value = transactionResponse.payload.id;
    userSignature.value = await web3Sign(
      transactionResponse.payload.operationHash
    );
    return await transactionSign("", txId.value, userSignature.value!);
  };

  const createTransaction = async (
    reCaptchaToken: string,
    to: string,
    amountGFAL: string
  ) => {
    return await $serverApi<GFALResponse<Transaction>>(`/api/transactions`, {
      method: "POST",
      headers: constructHeaders(userStore.authToken, {
        "X-Humanity-Token": reCaptchaToken,
      }),
      body: {
        to,
        amountGFAL,
      },
    });
  };

  const transactionSign = async (
    code: string = "",
    transactionId: string = txId.value!,
    signature: string = userSignature.value!
  ) => {
    return await $serverApi<GFALResponse<Transaction>>(
      `/api/transactions/${transactionId}/sign`,
      {
        method: "POST",
        headers: constructHeaders(userStore.authToken),
        body: {
          signature,
          code,
        },
      }
    );
  };

  return {
    getEstimatedGasFees,
    transfer,
    createTransaction,
    transactionSign,
  };
};
